import { useStaticQuery } from "gatsby"

export const useFormData = () => {
    const { allGfForm } = useStaticQuery(graphql`{
        allGfForm {
            edges {
                node {
                    ...GravityFormComponent
                }
            }
        }
    }`)
    
    return allGfForm
}